import classes from 'classnames';
import styles from './Select.module.scss';

export type SelectOption = {
  name: string;
  value: string | number;
};

export type SelectProps = {
  disabled?: boolean;
  value?: string | number;
  name?: string;
  label?: string;
  dataTest?: string;
  options?: SelectOption[];
  error?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLSelectElement>) => void;
  className?: string;
};

export function Select({
  disabled,
  value,
  name,
  label,
  dataTest = 'select',
  options,
  error,
  onChange,
  onBlur,
  className,
}: SelectProps) {
  return (
    <div
      className={
        error
          ? classes(
              styles.container,
              styles.field,
              styles['error-background'],
              styles['error-border'],
              styles['error-text'],
              className,
            )
          : classes(styles.container, styles.common, styles.field, className)
      }
    >
      <select
        disabled={disabled}
        name={name}
        data-test={dataTest}
        defaultValue={value || ''}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
        className={classes(
          styles.select,
          error && styles['error-background'],
          error && styles['error-text'],
        )}
      >
        <option className={styles['hidden-option']} />
        {options?.map(({ name, value }) => (
          <option
            className={classes(styles.option, error && styles['error-text'])}
            key={value}
            value={value}
          >
            {name}
          </option>
        ))}
      </select>

      <label
        className={classes(
          styles.label,
          (value || '').toString().length && styles.float,
        )}
      >
        {label}
      </label>
    </div>
  );
}
export default Select;
